<template>
  <div class="identity-verifications-page">
    <a-row type="flex" justify="space-between">
      <a-col :lg="8" :md="8" :sm="10" :xs="24">
        <h2 class="list-title">
          <font-awesome-icon
            class="anticon list-icon"
            :icon="['fas', 'arrow-right-arrow-left']"
          />
          <span>{{ labels.title }}</span>
        </h2>
        <p class="list-subtitle">{{ labels.subtitle }}</p>
      </a-col>
      <a-col :lg="16" :md="16" :xs="24">
        <a-row
          type="flex"
          justify="end"
          :gutter="[0, 8]"
          :style="{
            alignItems: 'flex-end',
            marginTop: '25px',
            marginBottom: '10px',
            textAlign: 'right',
          }"
          class="row-reverse"
        >
          <a-col :xs="24" :md="13" :lg="15">
            <a-input-search
              :placeholder="labels.placeholderSearch"
              style="width: 100%"
              @search="handleSearch"
              allowClear
            />
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <a-tabs
          type="card"
          :defaultActiveKey="STATUS.PENDING"
          :animated="true"
          @change="handleChangeTab"
          :activeKey="activeTab"
        >
          <a-tab-pane :key="STATUS.PENDING" :tab="statuses[1].label">
            <standard-table
              v-if="STATUS.PENDING === activeTab"
              ref="standardTablePending"
              :fetchService="fetchIdentityVerifications"
              :columns="columns"
              :locale="locale"
              :handleShowTotal="handleShowTotal"
              v-bind="!isMobile && { scroll: { x: true } }"
              :paginationType="isMobile ? 'arrows' : 'numbers'"
              :customRow="handleCustomRow"
              :defaultFilters="{ status: STATUS.PENDING }"
              :showSizeChanger="true"
              :pageSizeOptions="['10', '20', '50', '100']"
            />
          </a-tab-pane>
          <a-tab-pane :key="STATUS.ALL" :tab="statuses[0].label">
            <standard-table
              v-if="STATUS.ALL === activeTab"
              ref="standardTableAll"
              :fetchService="fetchIdentityVerifications"
              :columns="columns"
              :locale="locale"
              :handleShowTotal="handleShowTotal"
              v-bind="!isMobile && { scroll: { x: true } }"
              :paginationType="isMobile ? 'arrows' : 'numbers'"
              :customRow="handleCustomRow"
              :showSizeChanger="true"
              :pageSizeOptions="['10', '20', '50', '100']"
            />
          </a-tab-pane>
          <a-tab-pane :key="STATUS.APPROVED" :tab="statuses[2].label">
            <standard-table
              v-if="STATUS.APPROVED === activeTab"
              ref="standardTableApproved"
              :fetchService="fetchIdentityVerifications"
              :columns="columns"
              :locale="locale"
              :handleShowTotal="handleShowTotal"
              v-bind="!isMobile && { scroll: { x: true } }"
              :paginationType="isMobile ? 'arrows' : 'numbers'"
              :customRow="handleCustomRow"
              :defaultFilters="{ status: STATUS.APPROVED }"
              :showSizeChanger="true"
              :pageSizeOptions="['10', '20', '50', '100']"
            />
          </a-tab-pane>
          <a-tab-pane :key="STATUS.REJECTED" :tab="statuses[3].label">
            <standard-table
              v-if="STATUS.REJECTED === activeTab"
              ref="standardTableRejected"
              :fetchService="fetchIdentityVerifications"
              :columns="columns"
              :locale="locale"
              :handleShowTotal="handleShowTotal"
              v-bind="!isMobile && { scroll: { x: true } }"
              :paginationType="isMobile ? 'arrows' : 'numbers'"
              :customRow="handleCustomRow"
              :defaultFilters="{ status: STATUS.REJECTED }"
              :showSizeChanger="true"
              :pageSizeOptions="['10', '20', '50', '100']"
            />
          </a-tab-pane>
        </a-tabs>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import _ from "lodash";
import labels from "@/utils/labels";
import StandardTable from "../../../components/core/table/StandardTable.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { DATE_FORMAT, adminPageTitle } from "../../../utils/utils";
const STATUS = {
  PENDING: "pending",
  ALL: "all",
  SUCCESS: "rejected",
  APPROVED: "approved",
};
const initialState = {
  dateRange: [],
  type: [],
  origin: [],
  user: [],
  status: [],
};
const formInitialState = {
  reject_reason: "",
};
export default {
  components: { StandardTable },
  name: "IdentityVerificationList",
  metaInfo: {
    title: adminPageTitle("Identity Verifications"),
  },
  data() {
    return {
      labels: labels.identityVerifications,
      search: "",
      filters: _.cloneDeep(initialState),
      form: _.cloneDeep(formInitialState),
      activeRow: null,
      STATUS,
      activeTab: STATUS.PENDING,
      statuses: [
        {
          label: labels.identityVerifications.statuses.all,
          value: "all",
        },
        {
          label: labels.identityVerifications.statuses.pending,
          value: "pending",
        },
        {
          label: labels.identityVerifications.statuses.approved,
          value: "approved ",
        },
        {
          label: labels.identityVerifications.statuses.rejected,
          value: "rejected",
        },
      ],
    };
  },
  filters: {
    ucwords(value) {
      if (!value) return "";
      value = value.toString();
      return value
        .split(" ")
        .map((item) => _.capitalize(item))
        .join(" ");
    },
  },
  methods: {
    ...mapActions("identityVerification", ["fetchIdentityVerifications"]),
    handleOpenImage(url) {
      if (url) {
        // CREATE IMG AND OPEN IN NEW TAB
        const img = document.createElement("img");
        img.src = url;
        img.style.maxWidth = "520px";
        const w = window.open("about:blank", "_blank", "width=520,height=auto");
        w?.document.write(img.outerHTML);
      }
    },
    getTableRefs() {
      switch (this.activeTab) {
        case STATUS.PENDING:
          return this.$refs.standardTablePending;
        case STATUS.REJECTED:
          return this.$refs.standardTableRejected;
        case STATUS.APPROVED:
          return this.$refs.standardTableApproved;
        case STATUS.ALL:
        default:
          return this.$refs.standardTableAll;
      }
    },
    handleReloadTable() {
      let filtersTable = this.getTableRefs()?.filters;
      let result = { ...filtersTable };
      this.getTableRefs()?.handleFilters(result);
    },
    handleSearch(search) {
      this.$nextTick(() => {
        this.getTableRefs().handleSearch(search);
      });
    },
    handleShowTotal(total, range) {
      return `${range[0]}-${range[1]} de ${total}`;
    },
    statusColor(status = "approved") {
      switch (status) {
        case "approved":
          return "#28a745";
        case "pending":
          return "#ffc107";
        case "rejected":
          return "#f50";
        default:
          return "default";
      }
    },
    statusText(status = this.labels.statuses.approved) {
      return this.labels.statuses[status] ?? " - ";
    },
    handleCustomRow(_, index) {
      return {
        on: {
          click: () => {
            this.activeRow = this.activeRow === index ? null : index;
          },
        },
      };
    },
    handleChangeTab(key) {
      this.activeTab = key;
    },
  },
  computed: {
    ...mapGetters("adminAuth", ["getLoggedUser"]),
    ...mapState("layout", ["screenWidth"]),
    isMobile() {
      return this.screenWidth < 600;
    },
    locale() {
      return {
        emptyText: this.labels.table.emptyText,
      };
    },
    columns() {
      return [
        {
          title: this.labels.table.columns.user,
          dataIndex: "user",
          key: "user",
          sorter: true,
          hidden: this.isMobile,
          customRender: (text) => {
            return `${text.firstname} ${text.lastname} (${text?.email || "-"})`;
          },
        },
        {
          title: this.labels.table.columns.dfp,
          dataIndex: "document_front_path",
          key: "document_front_path",
          sorter: false,
          hidden: this.isMobile,
          customRender: (text) => {
            return text ? (
              <a-button
                type="primary"
                ghost
                onClick={() => this.handleOpenImage(text)}
              >
                {this.labels.viewDocument}
              </a-button>
            ) : (
              "-"
            );
          },
        },
        {
          title: this.labels.table.columns.dbp,
          dataIndex: "document_back_path",
          key: "document_back_path",
          sorter: false,
          hidden: this.isMobile,
          customRender: (text) => {
            return text ? (
              <a-button
                type="primary"
                ghost
                onClick={() => this.handleOpenImage(text)}
              >
                {this.labels.viewDocument}
              </a-button>
            ) : (
              "-"
            );
          },
        },
        {
          title: this.labels.table.columns.selfie,
          dataIndex: "selfie_path",
          key: "selfie_path",
          sorter: false,
          hidden: this.isMobile,
          customRender: (text) => {
            return text ? (
              <a-button
                type="primary"
                ghost
                onClick={() => this.handleOpenImage(text)}
              >
                {this.labels.viewDocument}
              </a-button>
            ) : (
              "-"
            );
          },
        },
        {
          title: this.labels.table.columns.status.title,
          dataIndex: "status",
          key: "status",
          sorter: true,
          hidden: this.isMobile || this.activeTab !== STATUS.ALL,
          customRender: (text) => {
            return (
              <span style="display: flex; flex-direction: column; gap: 5px;">
                <a-tag color={this.statusColor(text?.toLowerCase())}>
                  {text ? this.labels.statuses[text?.toLowerCase()] : "-"}
                </a-tag>
              </span>
            );
          },
        },
        {
          title: this.labels.table.columns.createdAt,
          dataIndex: "created_at",
          key: "created_at",
          hidden: this.isMobile,
          customRender: (text, record) => {
            return this.$moment(text || record?.created_at).format(
              DATE_FORMAT.MOMENT_DATE_TIME
            );
          },
        },
        {
          title: this.labels.table.columns.action.title,
          dataIndex: "action",
          key: "action",
          width: "120px",
          hidden: this.isMobile,
          customRender: (_, record) => {
            return (
              <div class="action-buttons">
                <router-link
                  to={{
                    name: "admin.identity-verifications.view",
                    params: { id: record.id },
                  }}
                  title={this.labels.table.columns.action.view}
                >
                  <a-button type="link" icon="eye" class="action-button-view" />
                </router-link>
              </div>
            );
          },
        },
        {
          title: this.labels.table.columns.identityVerifications,
          dataIndex: "identity-verifications",
          key: "identity-verifications",
          sorter: false,
          hidden: !this.isMobile,
          customRender: (_, record, index) => {
            // Card item design
            const color = this.statusColor(record.status?.toLowerCase());
            return (
              <div class="list-item">
                <div class="list-item-head">
                  <div
                    class="list-item-head-header"
                    style={{ borderColor: color }}
                  >
                    <span>
                      {this.$options.filters.ucwords(
                        this.$moment(record.created_at).format(
                          DATE_FORMAT.MOMENT_DAY_MONTH
                        )
                      )}
                    </span>
                    <small>
                      {this.$moment(record.created_at)
                        .format(DATE_FORMAT.MOMENT_TIME)
                        .toUpperCase()}
                    </small>
                  </div>
                  <div class="list-item-head-content">
                    <div class="list-item-head-content-user">
                      <span>
                        {record.user.firstname} {record.user.lastname}
                      </span>
                    </div>
                    <div class="list-item-head-content-email">
                      <span>{record.user?.email}</span>
                    </div>
                  </div>
                  <div class="list-item-head-footer">
                    <div
                      class="list-item-head-footer-status"
                      style="display: flex; gap: 5px; flex-wrap: wrap; justify-content: center;"
                    >
                      <a-tag color={color}>
                        {record.status
                          ? this.labels.statuses[record.status?.toLowerCase()]
                          : "-"}
                      </a-tag>
                    </div>
                  </div>
                </div>
                {this.activeRow === index && (
                  <div class="list-item-actions">
                    <a-button-group>
                      <router-link
                        class="view-button ant-btn ant-btn-primary ant-btn-block"
                        onClick={(event) => event.stopPropagation()}
                        to={{
                          name: "admin.identity-verifications.view",
                          params: { id: record.id },
                        }}
                        title={this.labels.table.columns.action.view}
                      >
                        {this.labels.table.columns.action.view}
                      </router-link>
                    </a-button-group>
                  </div>
                )}
              </div>
            );
          },
        },
      ].filter((col) => !col.hidden);
    },
    serverDateFormat() {
      return DATE_FORMAT.SERVER_DATE;
    },
  },
};
</script>
<style lang="scss">
@import "../../../assets/scss/variable";
.identity-verifications-page {
  .list {
    &-title {
      margin-bottom: 10px;
      .list-icon {
        margin-right: 10px;
      }
    }
    &-subtitle {
      margin-bottom: 10px;
    }
  }
  .add-button {
    color: color(primary);
    border-color: color(primary);
    margin-left: 10px;
  }
  .action-buttons {
    display: flex;
    justify-content: space-between;
    .action-button-view {
      color: color(primary);
    }
    .action-button-cancel {
      color: color(danger);
    }
  }
  @media screen and (max-width: $screen-mobile) {
    .row-reverse {
      flex-direction: column-reverse;
    }
  }
  .list-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
    &-head {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      gap: 6px;
      &-header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2px;
        max-width: 22%;
        border-right: 4px solid color(border);
        .success {
          color: color(success);
        }
        .warning {
          color: color(warning);
        }
        .danger {
          color: color(danger);
        }
        span {
          font-size: 14px;
          font-weight: 600;
        }
        small {
          font-size: 12px;
          font-weight: 400;
          padding-right: 4px;
        }
      }
      &-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        gap: 2px;
        max-width: 53%;
        overflow: hidden;
        &-user {
          span {
            font-size: 14px;
            font-weight: 600;
            text-overflow: ellipsis;
          }
        }
        &-email {
          span {
            font-size: 12px;
            font-weight: 400;
            text-overflow: ellipsis;
          }
        }
      }
      &-footer {
        max-width: 25%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 2px;
        &-status {
          span {
            font-size: 12px;
            font-weight: 400;
          }
          .ant-tag {
            padding: 0;
            margin: 0;
            padding-left: 2px;
            padding-right: 2px;
          }
        }
      }
    }
    &-actions {
      width: 100%;
      margin-top: 10px;
      .ant-btn-group {
        width: 100%;
        .more-info-button,
        .view-button,
        .cancel-button {
          width: 100%;
        }
      }
    }
  }
}
</style>
